import {
  DOUBLE_ROOM_COMBINATIONS,
  INDIVIDUAL_ROOM_COMBINATIONS,
  QUADRUPLE_ROOM_COMBINATIONS,
  TRIPLE_ROOM_COMBINATIONS,
} from '@/constants/HotelRoomTypes';
import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { findAllHotelRoomCombinations, Room } from '../findAllRoomCombinations';

export const getCombinationsFromHotelCategory = (
  category: Required<
    Required<
      CircuitDayFormData['steps'][number]['accommodations']
    >['standardBenefit']
  >['hotel']['HotelRoomCategory'][number],
  nbAdults: number,
  nbChildren: number,
  nbAdolescents: number,
) => {
  const individualRooms = category.roomTypes.includes('individual')
    ? category.individualRoomOptions.map(
        (i) => INDIVIDUAL_ROOM_COMBINATIONS[i] as Room,
      )
    : [];
  const doubleRooms = category.roomTypes.includes('double')
    ? category.doubleRoomOptions.map((i) => DOUBLE_ROOM_COMBINATIONS[i] as Room)
    : [];
  const tripleRooms = category.roomTypes.includes('triple')
    ? category.tripleRoomOptions.map((i) => TRIPLE_ROOM_COMBINATIONS[i] as Room)
    : [];
  const quadrupleRooms = category.roomTypes.includes('quadruple')
    ? category.quadrupleRoomOptions.map(
        (i) => QUADRUPLE_ROOM_COMBINATIONS[i] as Room,
      )
    : [];

  const allRooms = [
    ...individualRooms,
    ...doubleRooms,
    ...tripleRooms,
    ...quadrupleRooms,
  ];
  return findAllHotelRoomCombinations(
    allRooms,
    nbAdults,
    nbChildren,
    nbAdolescents,
  );
};
